module.exports = __webpack_public_path__ + "static/media/store-in-store-1550x930.5199e353.jpg";